// TODO: We should ask the instructor team what they call this?
export const acknowledgementOfClinicalContext = [
  'I acknowledge that this class is not a substitute for professional advice, diagnosis, or',
  'treatment. I will contact my healthcare provider if I need deeper therapeutic or',
  'clinical support.',
].join(' ');
